
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.997 32H3.998A4 4 0 010 28V4.006a4 4 0 014-4h11.997c1.34-.02 1.871.03 2 .03v-.03l7.999 7.999V28a4 4 0 01-4 3.999zm-4-29.995v4a2 2 0 002 1.999h4l-6-6zm6 7.999h-4a4 4 0 01-4-4s-.047-1.605-.028-4H4a2 2 0 00-2 2v23.997a2 2 0 002 2h17.998c1.104 0 2-.896 2-2V10.004zm-5 13.997H6.999a1 1 0 010-2h11.998a1 1 0 010 2zm0-5.999H6.999a1 1 0 010-2h11.998a1 1 0 010 2z","fill":"#9A9B9C"}})])
          )
        }
      }
    